const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M5.5 2.75H2.75V13.25H5.5" stroke="black" strokeWidth="1.1" strokeLinecap="square" />
    <path d="M7.25 8H12.25" stroke="black" strokeWidth="1.1" strokeLinecap="square" />
    <path d="M10.25 5.75L12.75 8L10.25 10.25" stroke="black" strokeWidth="1.1" strokeLinecap="square" />
  </svg>
);

export default LogoutIcon;
